import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Drivers from './pages/Drivers';
import DriverDetail from './pages/DriverDetail';
import Assessments from './pages/Assessments';
import Analytics from './pages/Analytics';

import CoachScheduler from './pages/CoachScheduler';
import DriverReport from './pages/DriverReport';
import Users from './pages/Users';
import VCR from './pages/VCR';
import Layout from './components/Layout';
import SessionTimeout from './components/SessionTimeout';
import { ThemeProvider } from './contexts/ThemeContext';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  const storedUser = (() => {
    try {
      const token = localStorage.getItem('token');
      const userData = localStorage.getItem('user');
      if (token && userData) return JSON.parse(userData);
      return null;
    } catch {
      return null;
    }
  })();

  const [user, setUser] = useState(storedUser);
  const [loading] = useState(false);

  const handleLogin = (userData, token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  return (
    <ThemeProvider>
      <div className="App">
        {/* Tyremark Watermark */}
        <div 
          className="no-print"
          style={{
            position: 'fixed',
            bottom: '-200px',
            right: '-200px',
            width: '1000px',
            height: '1000px',
            backgroundImage: 'url(https://customer-assets.emergentagent.com/job_driver-assess-track/artifacts/kjzzzmh0_tyremark.png)',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            opacity: 0.18,
            transform: 'rotate(45deg)',
            pointerEvents: 'none',
            zIndex: 0
          }}
        />
        <BrowserRouter>
          {user && <SessionTimeout onLogout={handleLogout} />}
          <Routes>
            <Route path="/login" element={user ? <Navigate to="/" /> : <Login onLogin={handleLogin} />} />
          <Route path="/" element={user ? <Layout user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}>
            <Route index element={<Dashboard />} />
            <Route path="drivers" element={<Drivers />} />
            <Route path="drivers/:driverId" element={<DriverDetail />} />
          <Route path="drivers/:driverId/driver-report" element={<DriverReport />} />
            <Route path="assessments" element={<Assessments />} />
            <Route path="analytics" element={<Analytics />} />
            {/* Reports moved to per-driver report route */}
          <Route path="coach-scheduler" element={<CoachScheduler currentUser={user} />} />
            <Route path="vcr" element={<VCR />} />
            <Route path="users" element={<Users />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
      </div>
    </ThemeProvider>
  );
}

export default App;